import React, { useEffect, useRef, useState } from 'react';
import { ZoomIn } from 'lucide-react';

/**
 * Siçanı şəklin üzərində gəzdirəndə həmin nöqtə böyüyür.
 * Yalnız siçanlı cihazlarda işləyir (telefonda hover olmur).
 * Klik -> onOpen() çağırılır (tam ekran üçün).
 */
const ImageZoom = ({ src, alt = '', onOpen, className = '', zoom = 2.2 }) => {
  const [origin, setOrigin] = useState('50% 50%');
  const [active, setActive] = useState(false);
  const [canHover, setCanHover] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return;
    const mq = window.matchMedia('(hover: hover) and (pointer: fine)');
    const update = () => setCanHover(mq.matches);
    update();
    mq.addEventListener?.('change', update);
    return () => mq.removeEventListener?.('change', update);
  }, []);

  const handleMove = (e) => {
    const rect = ref.current?.getBoundingClientRect();
    if (!rect) return;
    const x = ((e.clientX - rect.left) / rect.width) * 100;
    const y = ((e.clientY - rect.top) / rect.height) * 100;
    setOrigin(`${Math.min(100, Math.max(0, x))}% ${Math.min(100, Math.max(0, y))}%`);
  };

  return (
    <div
      ref={ref}
      role="button"
      tabIndex={0}
      aria-label="Şəkli tam ekranda aç"
      onClick={onOpen}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onOpen?.();
        }
      }}
      onMouseEnter={() => canHover && setActive(true)}
      onMouseLeave={() => setActive(false)}
      onMouseMove={canHover ? handleMove : undefined}
      className={`relative overflow-hidden cursor-zoom-in group select-none ${className}`}
    >
      <img
        src={src}
        alt={alt}
        draggable={false}
        className="w-full h-full object-cover transition-transform duration-200 ease-out"
        style={{
          transformOrigin: origin,
          transform: active ? `scale(${zoom})` : 'scale(1)',
        }}
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = 'https://via.placeholder.com/600x800?text=No+Image';
        }}
      />

      {/* İpucu */}
      <span
        className={`pointer-events-none absolute bottom-3 right-3 flex items-center gap-1.5 bg-white/90 backdrop-blur px-2.5 py-1.5 rounded-full text-[11px] font-medium text-gray-800 shadow-sm transition-opacity duration-200 ${
          active ? 'opacity-0' : 'opacity-100'
        }`}
      >
        <ZoomIn className="w-3.5 h-3.5" strokeWidth={2} />
        {canHover ? 'Böyüt' : 'Toxun'}
      </span>
    </div>
  );
};

export default ImageZoom;
